import BackupIndex from "@/views/backup/BackupIndex.vue";

const backupRouter = [
  {
    path: "/backup",
    name: "backup-index",
    component: BackupIndex,
    meta: {
      layout: "default",
      role: ["superadmin"],
      public: false,
    },
  },
];

export default backupRouter;
